<template>
  <div class="common-page">
    <HeroText
      :heroH1="''"
      :heroH2="currentPage.fields.title"
      :heroP="introduction"
      :internalPage="true"/>
    <div class="common-page__content">
      <div v-html="description"></div>
    </div>
    <glaxiFooter />
  </div>
</template>

<script>
import { BLOCKS, MARKS } from '@contentful/rich-text-types'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'

import HeroText from '@/components/HeroText/HeroText.vue'
import GlaxiFooter from '@/components/GlaxiFooter/GlaxiFooter.vue'

const options = {
  renderNode: {
    [BLOCKS.EMBEDDED_ASSET]: (node, next) => {
      return `<div class="blog-post__content-container__image"><img src="${node.data.target.fields.file.url}" alt="" width="${node.data.target.fields.file.details.image.width}" height="${node.data.target.fields.file.details.image.height}" alt="${node.data.target.fields.title}"></div>`
    }
  },
  renderMark: {
    // Example
    [MARKS.BOLD]: text => `<strong>${text}<strong>`
    // [MARKS.CODE]
  }
}

export default {
  name: 'Common',
  components: {
    HeroText,
    GlaxiFooter
  },
  props: {
    currentPage: {
      type: Object,
      required: false
    }
  },
  computed: {
    description: {
      get () {
        if (typeof this.currentPage.fields.body === 'undefined') return ''
        return documentToHtmlString(this.currentPage.fields.body, options)
      }
    },
    introduction: {
      get () {
        if (typeof this.currentPage.fields.intro === undefined) return ''
        return this.currentPage.fields.intro
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./common.scss";
</style>